import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["beforeBack", "tourKey", "stepKey", "children", "use", "size"];
import { useContext } from 'react';
import emptyFunction from 'react-utils/emptyFunction';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import TourContext from '../contexts/TourContext';
import handleCallback from '../lib/handleCallback';
import { TourButtonLabel } from '../constants/styles';
import styled from 'foundations-theming/utils';
const BackButtonLabel = styled(TourButtonLabel).withConfig({
  displayName: "UITourBackButton__BackButtonLabel"
})([".hs-private.hs-private.hs-private &{color:inherit;}"]);
import { hasRedesignGate } from '../utils/redesignGate';
import UITourBackButtonLegacy from './UITourBackButton.legacy';
import { jsx as _jsx } from "react/jsx-runtime";
const UITourBackButtonModern = props => {
  const {
    tour
  } = useContext(TourContext);
  const {
      beforeBack = emptyFunction,
      tourKey,
      stepKey,
      children: childrenProp,
      use = 'control-on-fill',
      size = 'xs'
    } = props,
    buttonProps = _objectWithoutPropertiesLoose(props, _excluded);
  if (!tour.canGoBack()) {
    return /*#__PURE__*/_jsx("div", {});
  }
  const children = childrenProp !== null && childrenProp !== void 0 ? childrenProp : /*#__PURE__*/_jsx(BackButtonLabel, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "shepherd-react.back"
    })
  });
  const {
    back,
    getTour,
    getStep
  } = tour;
  const handleClick = evt => {
    if (props.onClick) {
      props.onClick(evt);
    }
    handleCallback(beforeBack, back, {
      tourKey: tourKey !== null && tourKey !== void 0 ? tourKey : getTour(),
      stepKey: stepKey !== null && stepKey !== void 0 ? stepKey : getStep()
    });
  };
  return /*#__PURE__*/_jsx(Button, Object.assign({
    use: use,
    size: size
  }, buttonProps, {
    onClick: handleClick,
    children: children
  }));
};
const UITourBackButton = props => {
  if (hasRedesignGate()) {
    return /*#__PURE__*/_jsx(UITourBackButtonModern, Object.assign({}, props));
  }
  return /*#__PURE__*/_jsx(UITourBackButtonLegacy, Object.assign({}, props));
};
export { UITourBackButtonModern };
export default UITourBackButton;